import { LIVIA_LS_KEY } from 'constants/app'

export const clearStorage = (keys: Array<string>) => {
    keys.forEach(key => {
        sessionStorage.removeItem(key)
    })
}

export function clearAllNavStorage() {
    const localStorageArray = Object.keys(localStorage)
    const sessionStorageArray = Object.keys(sessionStorage)

    localStorageArray.concat(sessionStorageArray).forEach(key => {
        if (key.startsWith('@NSW')) {
            localStorage.removeItem(key)
            sessionStorage.removeItem(key)
        }
    })
}

export const getTokenFromStorage = (): string => {
    const storage = localStorage.getItem(LIVIA_LS_KEY)

    if (storage) {
        return JSON.parse(storage).token
    }

    return ''
}
